export default function Debug() {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Debug Information</h1>

        <div className="space-y-6">
          {/* Environment Variables */}
          <div className="border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Environment Variables</h2>
            <div className="space-y-3">
              <div className="flex justify-between items-center p-3 bg-muted rounded">
                <span className="font-mono text-sm">VITE_SUPABASE_URL</span>
                <span className={supabaseUrl ? '✅' : '❌'}>
                  {supabaseUrl ? 'SET' : 'MISSING'}
                </span>
              </div>
              {supabaseUrl && (
                <div className="text-xs bg-muted/50 p-2 rounded font-mono break-all">
                  {supabaseUrl}
                </div>
              )}

              <div className="flex justify-between items-center p-3 bg-muted rounded mt-4">
                <span className="font-mono text-sm">VITE_SUPABASE_ANON_KEY</span>
                <span className={supabaseAnonKey ? '✅' : '❌'}>
                  {supabaseAnonKey ? 'SET' : 'MISSING'}
                </span>
              </div>
              {supabaseAnonKey && (
                <div className="text-xs bg-muted/50 p-2 rounded font-mono break-all">
                  {supabaseAnonKey.substring(0, 50)}...
                </div>
              )}
            </div>
          </div>

          {/* Status Summary */}
          <div className="border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Status</h2>
            <div className="space-y-2">
              <p>
                {supabaseUrl && supabaseAnonKey ? (
                  <span className="text-green-600 font-semibold">✅ Supabase is properly configured</span>
                ) : (
                  <span className="text-red-600 font-semibold">❌ Supabase configuration is missing</span>
                )}
              </p>
              {(!supabaseUrl || !supabaseAnonKey) && (
                <p className="text-sm text-muted-foreground mt-4">
                  To fix this, add environment variables to Vercel:
                  <br />
                  1. Go to Vercel Dashboard
                  <br />
                  2. Click your project
                  <br />
                  3. Settings → Environment Variables
                  <br />
                  4. Add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY
                  <br />
                  5. Redeploy
                </p>
              )}
            </div>
          </div>

          {/* Browser Info */}
          <div className="border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Browser</h2>
            <div className="text-sm space-y-2">
              <p>User Agent: {navigator.userAgent}</p>
              <p>URL: {window.location.href}</p>
            </div>
          </div>
        </div>

        <div className="mt-8">
          <a href="/" className="text-blue-600 hover:underline">
            ← Back to Login
          </a>
        </div>
      </div>
    </div>
  );
}
